<div v-show="showGallery" class="tt-c-gallery">
  <div class="tt-c-gallery__heading" :class="{'tt-u-align-center' : !paginationTop}" v-html="$msg('gallery.title', [total], total)"></div>
  <tt-pagination v-if="paginationTop" class="tt-c-gallery__pagination--top"
                  :currentPage="currentPage" @updatePage="pageChange" :total="paginationTotal"
                  :pageSize="imagesPerPage" :useIcons="true" :hidePageList="true" :isButtonStyle="useButtonArrowStyle"></tt-pagination>
  <div class="tt-c-gallery__wrap">
    <div ref="galleryOuterEl" class="tt-c-gallery__outer">
      <div class="tt-c-gallery__inner" :style="galleryTransform">
        <template v-for="(mediaItem, mediaIndex) in media">
          <tt-gallery-item :mediaItem="mediaItem" 
                           :mediaSize="mediaSize"
                           :columnSpacing="galleryConfig.columnSpacing"
                           :isHidden="isItemHidden(mediaIndex)"
                           :showCaption="showCaptions"
                           :truncateLength="galleryConfig.truncateLength"
                           @click.prevent="openModal(mediaIndex)"
                           :key="mediaItem.id"></tt-gallery-item>
        </template>
      </div>
    </div>
    <tt-pagination v-if="paginationAsOverlay" class="tt-c-gallery__pagination--overlay" :style="{top: overlayBtnX + 'px'}"
                   :currentPage="currentPage" @updatePage="pageChange" :total="paginationTotal"
                   :pageSize="imagesPerPage" :useIcons="true" :hideBackNext="false"
                   :hidePageList="true" :isButtonStyle="useButtonArrowStyle"></tt-pagination>
  </div>
  <tt-pagination v-if="paginationBottom" :class="{'tt-c-gallery__pagination--bottom-no-progress': !galleryConfig.showProgressBar}"
                 :currentPage="currentPage" @updatePage="pageChange" :total="paginationTotal"
                 :pageSize="imagesPerPage" :useIcons="true" :hideBackNext="!paginationBottom"
                 :hidePageList="true" :isButtonStyle="useButtonArrowStyle">
    <tt-progress-bar v-if="galleryConfig.showProgressBar" class="tt-c-gallery__pagination-progress-bar"
                     :minValue="1" :maxValue="numberOfPages" :value="currentPage"></tt-progress-bar>
  </tt-pagination>
  <tt-progress-bar v-if="galleryConfig.showProgressBar && !paginationBottom" class="tt-c-gallery__progress-bar"
                   :minValue="1" :maxValue="numberOfPages" :value="currentPage"></tt-progress-bar>
</div>



// WEBPACK FOOTER //
// ./src/components/gallery/gallery.html